import { componentFactory, datasetFactory } from '../lib/lib';
import Column3dGroup from '../datasets/groups/column.3d';

/**
 * Create dataset for 3d charts
 * @param {Object} chart Chart API
 */
export default function (chart) {
  let jsonData = chart.getFromEnv('dataSource'),
    datasetsJSON = jsonData.dataset,
    children = chart.getChildren(),
    canvas = children.canvas[0],
    vCanvas,
    datasetParent = vCanvas = canvas.getChildren('vCanvas')[0],
    DsGroupClass,
    DSClass,
    dsType = chart.config.defaultDatasetType || '',
    groupManager,
    groupManager3d;

  if (!datasetsJSON) {
    chart.setChartMessage();
  }

  componentFactory(vCanvas, Column3dGroup, 'datasetGroup_' + dsType);
  groupManager3d = vCanvas.getChildren('datasetGroup_' + dsType)[0];

  DsGroupClass = chart.getDSGroupdef();
  componentFactory(groupManager3d, DsGroupClass, 'datasetGroup_' + dsType);
  groupManager = groupManager3d.getChildren('datasetGroup_' + dsType);
  groupManager && (datasetParent = groupManager[0]);
  DSClass = chart.getDSdef();

  datasetFactory(datasetParent, DSClass, 'dataset', datasetsJSON.length, datasetsJSON);
}
